import { useNavigate } from 'react-router-dom';

export function usePartialConfigOnClose() {
    const navigate = useNavigate();

    return () => {
        navigate('/partial_config');
    };
}
